define(function (require) {
    "use strict";

    var LE = require("app");

    var template = require("personalization-web-agent-templates/widget-templates/widget-list/widgetListItemView.tmpl");

    var ActionsListItemView = require("personalization-web-agent-views/widget-views/widget-list/ActionsListItemView");

    var ACTION_IDS = {
        EDIT: "edit",
        HIDE: "hide",
        PILOT: "pilot",
        REMOVE: "remove"
    };

    var ICON_PREFIX = "widget-icon widget-icon-";

    var WidgetListItemView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetListItemView = Marionette.CompositeView.extend({
            template:template,
            itemView:ActionsListItemView,
            itemViewEventPrefix: "item",
            itemViewContainer:".actions-list tbody",
            ui : {
                actionsList : ".actions-list",
                listButton: ".list-button",
                buttonContainer: ".widget-list-item-container"
            },
            events : {
                "clickoutside": "_outsideClicked",
                "click .list-button" : "_onWidgetClick"
            },
            itemEvents: {
                "itemview:widget-action-clicked": "_onActionClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize : function (options) {
                LEPersonalization.logger.info("Initializing WidgetListItemView", "WidgetListItemView:initialize");
                this.vent = options.vent;
                this.title = this.model.getWidgetInitials();

                this.collection = this._getWidgetMenuActions();
                this._bindEvents();
            },

            customTemplateHelpers: function () {
                var widgetName = this.model.getName();
                var isCoreWidget = this.model.isCoreWidget();
                return {
                    title: isCoreWidget? "" : this.title,
                    tooltip: isCoreWidget ? LE.translator.translate("LEPersonalization.webAgent.widget.widgetName." + widgetName) : widgetName,
                    iconType: isCoreWidget ? ICON_PREFIX + widgetName : ""
                };
            },

            onRender:function(){
                LEPersonalization.logger.debug("Rendering WidgetListItemView", "WidgetListItemView:onRender");
                this._initListButtonState();
                if(this.collection.length === 0) {
                    this.ui.listButton.addClass("disable");
                }
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetListItemView", "WidgetListItemView:onClose");
            },

            _bindEvents: function(){
                this.listenTo(this.model, "change:enabled", this._onWidgetHidePropertyChange);
                this.listenTo(this.model, "change:mode", this._onWidgetPilotPropertyChange);
            },

            /************************** private functions *****************************************************/
            _initListButtonState: function(){
                this.ui.listButton.toggleClass("hidden-widget", !this.model.isEnabled());
                this.ui.listButton.toggleClass("pilot-widget", this.model.isPilotMode());
                this.ui.buttonContainer.toggleClass("unsupported", !LE.crossModule("webagent", LE.media.actions.request, LE.mediaCodes.webAgent.reqres.isWidgetConfigurable, this.model.getName()));
            },

            _onActionClick: function(componentId, eventName, value) {
                switch(value.actionId) {
                    case ACTION_IDS.EDIT:
                        this.vent.trigger("widget:edit", {model: this.model});
                        break;
                    case ACTION_IDS.HIDE:
                        this.vent.trigger("widget:hide", {model: this.model, state: value.state});
                        break;
                    case ACTION_IDS.PILOT:
                        this.vent.trigger("widget:pilot", {model: this.model, state: value.state});
                        break;
                    case ACTION_IDS.REMOVE:
                        this.vent.trigger("widget:remove", {model: this.model});
                        break;
                    default:
                        LEPersonalization.logger.error("invalid action ID passed", "WidgetListItemView:_onActionClick", value.actionId);
                        LEPersonalization.logger.graph({ name: "personalization:WidgetListItemView:_onActionClick:invalidActionID" });
                }
            },

            _onWidgetHidePropertyChange: function(model){
                this.ui.listButton.toggleClass("hidden-widget", !model.isEnabled());
                this.collection.get(ACTION_IDS.HIDE).set("toggleState", !model.isEnabled());
            },

            _onWidgetPilotPropertyChange: function(model){
                this.ui.listButton.toggleClass("pilot-widget", model.isPilotMode());
                this.collection.get(ACTION_IDS.PILOT).set("toggleState", model.isPilotMode());
            },

            _onWidgetClick : function () {
                if (this.ui.actionsList.is(":hidden") && this.collection.length > 0) {
                    this.ui.actionsList.show();
                }
            },

            _outsideClicked : function (event) {
                if(!$(event.target).hasClass("btn-toggle")){
                    this._closeActions();
                }
            },

            _closeActions : function () {
                this.ui.actionsList.hide();
            },

            /************************** Utility private functions that does not need "this" ********************/
            _getWidgetMenuActions: function () {
                var actions = [],
                    widgetType = this.model.getType(),
                    editAction = {
                        id: ACTION_IDS.EDIT,
                        "actionName": LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions." + ACTION_IDS.EDIT),
                        "toggleAvailable": false,
                        "toggleState": false
                    },
                    hideAction = {
                        id: ACTION_IDS.HIDE,
                        "actionName": LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions." + ACTION_IDS.HIDE),
                        "tooltip": LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions." + ACTION_IDS.HIDE + ".tooltip"),
                        "toggleAvailable": true,
                        "toggleState": !this.model.isEnabled()
                    },
                    pilotAction = {
                        id: ACTION_IDS.PILOT,
                        "actionName": LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions." + ACTION_IDS.PILOT),
                        "tooltip": LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions." + ACTION_IDS.PILOT + ".tooltip"),
                        "toggleAvailable": true,
                        "toggleState": this.model.isPilotMode()
                    },
                    removeAction = {
                        id: ACTION_IDS.REMOVE,
                        "actionName": LE.translator.translate("LEPersonalization.webAgent.widget.widgetList.actions." + ACTION_IDS.REMOVE),
                        "toggleAvailable": false,
                        "toggleState": false
                    };

                if(widgetType === this.model.TYPES.CORE) {
                    if(!LE.crossModule("webagent", LE.media.actions.request, LE.mediaCodes.webAgent.reqres.isMandatoryWidget, this.model.getName())) {
                        actions = [hideAction];
                    }
                } else {
                    actions = [editAction, hideAction, pilotAction, removeAction];
                }

                return new Backbone.Collection(actions);
            }
        });
    });
    WidgetListItemView.WIDGET_ACTION_IDS = ACTION_IDS;
    return WidgetListItemView;
});

